// Shared color palette extracted from colors already used across the app.
// Values are unchanged from what pages already used -- this centralizes them, it does not restyle anything.
// Near-duplicate blues/grays (customBlueN, neutralGrayN, etc.) are kept distinct on purpose:
// they render slightly differently today, so merging them is a design decision for a future pass, not this one.
const Colors = {

  // white
  white: "#ffffff",

  // black
  black: "#000000",

  // slate
  slate50: "#f8fafc",
  slate100: "#f1f5f9",
  slate200: "#e2e8f0",
  slate300: "#cbd5e1",
  slate400: "#94a3b8",
  slate500: "#64748b",
  slate600: "#475569",
  slate700: "#334155",
  slate800: "#1e293b",
  slate900: "#0f172a",

  // gray
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray900: "#111827",

  // neutralLight
  neutralLight1: "#f5f5f5",
  neutralLight2: "#eeeeee",
  neutralLight3: "#fcfcfc",
  neutralLight4: "#f9f9f9",
  neutralLight5: "#dddddd",
  neutralLight6: "#f1f1f1",
  neutralLight7: "#f0f0f0",

  // neutralGray
  neutralGray1: "#666666",
  neutralGray2: "#999999",
  neutralGray3: "#cccccc",

  // neutralDark
  neutralDark1: "#333333",

  // red
  red50: "#fef2f2",
  red100: "#fee2e2",
  red200: "#fecaca",
  red300: "#fca5a5",
  red500: "#ef4444",
  red600: "#dc2626",
  red700: "#b91c1c",
  red800: "#991b1b",

  // rose
  rose50: "#fff1f2",
  rose200: "#fecdd3",
  rose600: "#e11d48",

  // pomegranateRed
  pomegranateRed: "#c0392b",

  // orange
  orange50: "#fff7ed",
  orange200: "#fed7aa",
  orange500: "#f97316",

  // amber
  amber50: "#fffbeb",
  amber100: "#fef3c7",
  amber200: "#fde68a",
  amber400: "#fbbf24",
  amber500: "#f59e0b",
  amber600: "#d97706",
  amber700: "#b45309",
  amber800: "#92400e",

  // green
  green50: "#f0fdf4",
  green100: "#dcfce7",
  green200: "#bbf7d0",
  green300: "#86efac",
  green500: "#22c55e",
  green600: "#16a34a",
  green700: "#15803d",
  green800: "#166534",
  green900: "#14532d",

  // emerald
  emerald50: "#ecfdf5",
  emerald100: "#d1fae5",
  emerald200: "#a7f3d0",
  emerald500: "#10b981",
  emerald600: "#059669",
  emerald800: "#065f46",

  // muiGreen
  muiGreen800: "#2e7d32",

  // excelGreen
  excelGreen: "#217346",

  // cyan
  cyan50: "#ecfeff",
  cyan600: "#0891b2",

  // sky
  sky50: "#f0f9ff",
  sky100: "#e0f2fe",
  sky200: "#bae6fd",
  sky500: "#0ea5e9",
  sky700: "#0369a1",

  // blue
  blue50: "#eff6ff",
  blue100: "#dbeafe",
  blue200: "#bfdbfe",
  blue300: "#93c5fd",
  blue500: "#3b82f6",
  blue600: "#2563eb",
  blue700: "#1d4ed8",
  blue800: "#1e40af",

  // muiBlue
  muiBlue700: "#1976d2",
  muiBlue800: "#1565c0",
  muiBlue900: "#0d47a1",

  // customBlue
  customBlue1: "#eef0f3",
  customBlue2: "#2d6fbd",
  customBlue3: "#1e3a5f",
  customBlue4: "#c8d8f0",
  customBlue5: "#e3f0fb",
  customBlue6: "#b6d4f0",
  customBlue7: "#e8edf8",
  customBlue8: "#c7d4f0",
  customBlue9: "#1a3a5c",
  customBlue10: "#f0f4ff",
  customBlue11: "#1a3c6e",
  customBlue12: "#2a5298",
  customBlue13: "#eef3fb",
  customBlue14: "#f8f9fa",
  customBlue15: "#e8f0fe",

  // indigo
  indigo50: "#eef2ff",
  indigo100: "#e0e7ff",
  indigo200: "#c7d2fe",
  indigo400: "#818cf8",
  indigo500: "#6366f1",
  indigo600: "#4f46e5",
  indigo700: "#4338ca",
  indigo800: "#3730a3",

  // violet
  violet50: "#f5f3ff",
  violet200: "#ddd6fe",
  violet500: "#8b5cf6",
  violet600: "#7c3aed",
  violet800: "#5b21b6",

  // purple
  purple100: "#f3e8ff",

  // customGreen
  customGreen1: "#128269",

  // customTeal
  customTeal1: "#128197",
};

export default Colors;
